export const SET_BOOKINGS = 'SET_BOOKINGS';
export const SET_BOOKING = 'SET_BOOKING';
export const ADD_BOOKING = 'ADD_BOOKING';
export const UPDATE_BOOKING = 'UPDATE_BOOKING';
export const REMOVE_BOOKING = 'REMOVE_BOOKING';
export const CLEAR_BOOKING = 'CLEAR_BOOKING';
export const CLEAR_BOOKINGS = 'CLEAR_BOOKINGS';
